import { InboxOutlined, LoadingOutlined } from '@ant-design/icons';
import React from 'react';
import { DropzoneRootProps } from 'react-dropzone';
import styles from '../FilePicker.module.scss';

type DraggerProps = {
  getRootProps?: <T extends DropzoneRootProps>(props?: T) => T;
  isDragActive?: boolean;
  isDragReject?: boolean;
  isAbsolute?: boolean;
  isMultipleUpload?: boolean;
  loadingUpload?: boolean;
};

export const FilePickerDragger: React.FC<DraggerProps> = ({
  getRootProps,
  isDragActive,
  isDragReject,
  isAbsolute,
  isMultipleUpload,
  loadingUpload,
}) => {
  let rootProps = {};

  if (getRootProps) {
    rootProps = getRootProps();
  }

  return (
    <div
      {...rootProps}
      className={`ant-upload ant-upload-drag${isAbsolute ? ` ${styles.isAbsolute} ${styles.isActive}` : ''}${
        isDragActive ? ` ${styles.isActive}` : ''
      }${isDragReject ? ` ${styles.isReject}` : ''}`}
    >
      <span tabIndex={0} className="ant-upload ant-upload-btn" role="button">
        <div className="ant-upload-drag-container">
          <p className="ant-upload-drag-icon">{loadingUpload ? <LoadingOutlined /> : <InboxOutlined />}</p>
          <p className="ant-upload-text">{`${isAbsolute ? 'D' : 'Click or d'}rag file to this area to upload`}</p>
          <p className="ant-upload-hint">
            {isMultipleUpload ? 'Support for a single or bulk upload.' : 'Only single file upload.'}
          </p>
        </div>
      </span>
    </div>
  );
};
